import {
  Main,
  Container,
  Wrapper,
  LeftColumn,
  Paragraph,
  RightColumn,
  Image,
  List,
  Link,
} from "../../globalStyles";
import { VideoWrapper } from "./RouliBouli.styled";
import rouliBouli1 from "../../assets/images/rouli-bouli/rouli-bouli-1.jpg";
import rouliBouli2 from "../../assets/images/rouli-bouli/rouli-bouli-2.jpg";
import rouliBouli3 from "../../assets/images/rouli-bouli/rouli-bouli-3.jpg";
import rouliBouli4 from "../../assets/images/rouli-bouli/rouli-bouli-4.jpg";
import rouliBouli5 from "../../assets/images/rouli-bouli/rouli-bouli-5.jpg";
import mapRouliBouli from "../../assets/images/rouli-bouli/map-rouli-bouli.pdf";

const RouliBouli = () => {
  return (
    <Main>
      <Container>
        <Wrapper>
          <LeftColumn>
            <h2>
              <span>Rouli Bouli</span>
            </h2>
            <Paragraph>
              <p>
                Ce nouveau parcours de balles inédit ludique et interactif a été
                une véritable réussite attirant près de 20 000 rouliboulistes de
                juin à septembre 2024. Ode au bois local avec un quizz sur les
                essences de bois du val de Bagnes à retrouver le long du
                parcours, les visiteurs étaient invités, munis de leur balle
                réalisée en mélèze, à emprunter la route forestière reliant
                Bruson au Châble, le long de laquelle 15 constructions et
                mécanismes étaient à découvrir.
              </p>
            </Paragraph>
            <Paragraph>
              <h4>Les installations</h4>
              <p>
                Une dizaine d’installations ont été créées par différents
                intervenants, artisans locaux, artistes régionaux...
              </p>
              <p>
                Un demi-kilomètre de chéneaux, longe le chemin et nous conduit à
                chaque oeuvre. Les chéneaux sont fabriqués par le triage
                forestier Combins-Catogne. Leurs longueurs et formes, leurs
                essences ainsi que leurs types de fabrication sont diverses et
                variées.
              </p>
            </Paragraph>
            <Paragraph>
              <h4>Horaires</h4>
              <p>
                Ouvert tous les jours du 14 juin au 31 août de 10h00 à 18h00
              </p>
            </Paragraph>
            <Paragraph>
              <h4>Comment s’y rendre</h4>
              <p>
                Départ de la gare du Châble (parking sur place si vous venez en
                voiture), prendre le bus TMR jusqu’à «Bruson Valbord», lieu de
                départ du parcours.
              </p>
            </Paragraph>
            <Paragraph>
              <h4>Où acheter votre balle</h4>
              <List>
                <li>À l’Office du Tourisme du Châble (tous les jours)</li>
                <li>
                  À la Raclett’House, Bruson (tous les jours sauf mercredi)
                </li>
                <li>Au Carrefour du Village, Bruson (mardi au dimanche)</li>
                <li>À La Brusonette, Bruson (mardi au samedi)</li>
              </List>
            </Paragraph>
            <Paragraph>
              <h4>Tarifs</h4>
              <p>8 CHF par balle</p>
            </Paragraph>
            <Paragraph>
              <h4>Itinéraire</h4>
              <Link
                href={mapRouliBouli}
                target="_blank"
                rel="noopener noreferrer"
              >
                Plan du parcours
              </Link>
            </Paragraph>
            <Paragraph>
              <h4>Où grignoter une morse</h4>
              <p>
                Au{" "}
                <Link href="/carrefour-du-village">Carrefour du Village</Link>,
                à la Raclett’House ou acheter son pique-nique à{" "}
                <Link href="/epicerie-la-brusonette">La Brusonette</Link>.
              </p>
            </Paragraph>
            <Paragraph>
              <h4>Comment rentrer</h4>
              <p>
                Reprendre le bus TMR depuis l’arrêt «Bruson Village», sous
                l’école de Bruson ou descendre à pied jusqu’au Châble (35
                minutes de marche).
              </p>
              <Link
                href={mapRouliBouli}
                target="_blank"
                rel="noopener noreferrer"
              >
                Horaire des bus
              </Link>
            </Paragraph>
            <Paragraph>
              <h4>Infos du parcours</h4>
              <List>
                <li>3,7 km de randonnée</li>
                <li>102 m de montée</li>
                <li>162 m de descente</li>
                <li>2 h à pied (avec les arrêts)</li>
              </List>
            </Paragraph>
            <Paragraph>
              <h4>Pourquoi le parcours a changé</h4>
              <p>
                En raison d’une opposition, le parcours a dû être déplacé sur
                les hauts de Bruson et sera à nouveau éphémère.
              </p>
            </Paragraph>
          </LeftColumn>
          <RightColumn>
            <Image>
              <img src={rouliBouli1} alt="Rouli Bouli" />
              <figcaption>© Cyril Perregaux</figcaption>
            </Image>
            <Image>
              <img src={rouliBouli2} alt="Rouli Bouli" />
              <figcaption>© Cyril Perregaux</figcaption>
            </Image>
            <Image>
              <img src={rouliBouli3} alt="Rouli Bouli" />
              <figcaption>© Cyril Perregaux</figcaption>
            </Image>
            <Image>
              <img src={rouliBouli4} alt="Rouli Bouli" />
              <figcaption>© Cyril Perregaux</figcaption>
            </Image>
            <Image>
              <img src={rouliBouli5} alt="Rouli Bouli" />
              <figcaption>© Cyril Perregaux</figcaption>
            </Image>
            <VideoWrapper>
              <iframe
                src="https://www.youtube.com/embed/Wk1W3XPnIQU"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="YouTube video player"
                style={{ width: "100%", height: "100%" }}
                frameBorder="0"
              ></iframe>
            </VideoWrapper>
          </RightColumn>
        </Wrapper>
      </Container>
    </Main>
  );
};

export default RouliBouli;
